
import React from 'react';

interface NodeDifferenceIndicatorProps {
  difference: number;
}

export function NodeDifferenceIndicator({ difference }: NodeDifferenceIndicatorProps) {
  // Only show if there is a difference
  if (difference === 0) return null;

  return (
    <span className={`text-sm ${difference > 0 ? 'text-green-500' : 'text-red-500'}`}>
      {difference > 0 ? '+' : ''}{difference}
    </span>
  );
}
